var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.1653,
    height: 18.1653,
    rx: 9.08264,
    fill: "#00D88A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1616 5.45826C14.0912 5.38732 14.0075 5.33101 13.9153 5.29258C13.823 5.25416 13.7241 5.23438 13.6242 5.23438C13.5243 5.23438 13.4253 5.25416 13.3331 5.29258C13.2409 5.33101 13.1572 5.38732 13.0868 5.45826L7.44799 11.1046L5.07894 8.72801C5.00588 8.65744 4.91964 8.60195 4.82514 8.56471C4.73064 8.52747 4.62973 8.5092 4.52817 8.51096C4.42661 8.51272 4.32639 8.53446 4.23323 8.57495C4.14007 8.61544 4.05581 8.67388 3.98523 8.74693C3.91466 8.81999 3.85917 8.90623 3.82193 9.00073C3.78469 9.09523 3.76643 9.19614 3.76818 9.2977C3.76994 9.39926 3.79168 9.49948 3.83217 9.59264C3.87266 9.68579 3.9311 9.77006 4.00416 9.84063L6.9106 12.7471C6.98096 12.818 7.06468 12.8743 7.15691 12.9128C7.24914 12.9512 7.34807 12.971 7.44799 12.971C7.54791 12.971 7.64684 12.9512 7.73907 12.9128C7.83131 12.8743 7.91502 12.818 7.98538 12.7471L14.1616 6.57088C14.2384 6.50001 14.2997 6.41399 14.3417 6.31824C14.3836 6.22249 14.4052 6.1191 14.4052 6.01457C14.4052 5.91005 14.3836 5.80665 14.3417 5.7109C14.2997 5.61516 14.2384 5.52914 14.1616 5.45826Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/check-green.df4d14ccf572319ec3f12a9bb300668c.svg";
export { ForwardRef as ReactComponent };